module.exports = __webpack_public_path__ + "img/pantalla-2-9.dc11e49d.png";